/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBluetoothOff = createReactComponent("outline", "bluetooth-off", "IconBluetoothOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M16.438 16.45l-4.438 3.55v-8m0 -4v-4l5 4l-2.776 2.22m-2.222 1.779l-5 4", "key": "svg-1" }]]);

export { IconBluetoothOff as default };
//# sourceMappingURL=IconBluetoothOff.mjs.map
